"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_POD_USAGE_STATS } from "api";

export interface PodStatusDistribution {
  completed?: number;
  failed?: number;
  client_disconnected?: number;
}

export interface PodUsageStats {
  pod_id: string;
  total_generations: number;
  average_generations_per_hour: number;
  first_activity: string;
  last_activity: string;
  last_activity_minutes_ago: number;
  active_time_percentage: number;
  total_idle_time_minutes: number;
  idle_periods_count: number;
  currently_idle: boolean;
  shutdown_candidate: boolean;
  avg_processing_seconds_per_generation: number;
  status_distribution: PodStatusDistribution;
}

export interface PodUsageStatsResponse {
  pod_usage_stats: PodUsageStats[];
  time_window: string;
  idle_threshold_minutes: number;
  total_pods: number;
  shutdown_candidates: number;
}

export const fetchPodUsageStats = async (): Promise<PodUsageStatsResponse> => {
  return await fetch(GET_POD_USAGE_STATS, {
    method: "GET",
  });
};

const usePodUsageStats = () =>
  useQuery<PodUsageStatsResponse>({
    queryKey: ["podUsageStats"],
    queryFn: fetchPodUsageStats,
    enabled: typeof window === "object",
    refetchInterval: 5000,
  });

export default usePodUsageStats; 